import { EDIT_GUEST_FAILURE, EDIT_GUEST_REQUEST, EDIT_GUEST_SUCCESS, EditGuestActionTypes, EditGuestState } from './types';

const defaultState: EditGuestState = {
  isLoading: false,
  errorMessage: '',
};

export default function editGuest(state = defaultState, action: EditGuestActionTypes): EditGuestState {
  switch (action.type) {
    case EDIT_GUEST_REQUEST:
      return { ...state, isLoading: true };
    case EDIT_GUEST_SUCCESS:
      return { ...state, isLoading: false, errorMessage: '' };
    case EDIT_GUEST_FAILURE:
      return { ...state, isLoading: false, errorMessage: '' };
    default:
      return state;
  }
}
